module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eWe9g"))).then(() => parcelRequire('3a9aZ'));